import React from 'react';

import { formatDate } from '@app/services/formatDate.service';
import ECheckModal from '@FW/components/ECheckModal/ECheckModal';
import { LastTransactions } from '@FW/interfaces/transactions/LastTransactions';
import { formatReadableCardNumber } from '@utils/shared/content/formatCardNumber';
import { formatReadableNumber } from '@utils/shared/number/formatReadableNumber';
import { Typography } from 'antd';
import { ColumnsType } from 'antd/es/table';
import { t } from 'i18next';

const { Text } = Typography;

export const getWalletTransactionsColumns = (): ColumnsType<LastTransactions> => [
	{
		title: t('refill.historyColumnsDate'),
		dataIndex: 'checkDate',
		key: 'checkDate',
		width: 130,
		render: (v: any, record: LastTransactions) => formatDate(record.checkDate),
		sorter: {
			compare: (a: LastTransactions, b: LastTransactions) => {
				const first = new Date(a.checkDate).getTime();
				const second = new Date(b.checkDate).getTime();
				return first - second;
			},
		},
	},
	{
		title: t('transactions.columns.card'),
		dataIndex: 'fuelCardCode',
		key: 'fuelCardCode',
		sorter: {
			compare: (a: LastTransactions, b: LastTransactions) => {
				const first = a.fuelCardCode.trim().substring(0, 15);
				const second = b.fuelCardCode.trim().substring(0, 15);
				return Number(first) - Number(second);
			},
		},
		render: (v: any, record: LastTransactions) => {
			const card = v.split(',')[0];
			const holder = v.split(',')[1];
			return (
				<Text>
					{/*<Link to={`/cards/${card}`}>{formatReadableCardNumber(card)}</Link>*/}
					{formatReadableCardNumber(card)} {holder}
				</Text>
			);
		},
	},
	{
		title: t('transactions.columns.resource'),
		dataIndex: 'nomenclatureSalesName',
		key: 'nomenclatureSalesName',
		sorter: {
			compare: (a: LastTransactions, b: LastTransactions) =>
				b.nomenclatureSalesName.localeCompare(a.nomenclatureSalesName),
		},
		onFilter: (value: any, record: LastTransactions) =>
			record.nomenclatureSalesName.indexOf(value) === 0,
	},
	{
		title: t('transactions.columns.station'),
		dataIndex: 'gasStationTranslationName',
		key: 'gasStationTranslationName',
		sorter: {
			compare: (a: LastTransactions, b: LastTransactions) =>
				b.gasStationTranslationName.localeCompare(a.gasStationTranslationName),
		},
	},
	{
		title: t('transactions.columns.checkNumber'),
		dataIndex: 'checkNumber',
		key: 'checkNumber',
		align: 'center',
		width: 120,
		sorter: (a, b) => a.checkNumber - b.checkNumber,
		render: (v: any, record: LastTransactions) => (
			<ECheckModal checkId={record.registrar} checkNumber={v} />
		),
	},
	{
		title: t('transactions.columns.quantity'),
		dataIndex: 'quantity',
		key: 'quantity',
		align: 'center',
		width: 120,
		render: (v) => formatReadableNumber(v),
		sorter: (a, b) => a.quantity - b.quantity,
	},
	{
		title: t('transactions.columns.amount'),
		dataIndex: 'amount',
		key: 'amount',
		align: 'center',
		className: 'highlighted',
		width: 120,
		sorter: (a, b) => a.amount - b.amount,
		render: (v) => formatReadableNumber(v),
	},
];
